exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".head{\r\n    padding: 0px;\r\n}\r\n.popup-table-content{\r\n    background-color: #00d7c6 !important;\r\n    height: 100% !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/products/product-lead-popup/product-lead-popup.component.css
// module id = 647
// module chunks = 8